import { Component, createSignal, onMount } from 'solid-js'
import { useParams } from '@solidjs/router'
// import { aifansSubscriptionApi } from '../../store/data/aifans-subscription'

const SubscriptionCancelled: Component = () => {
  const params = useParams()
  const [loading, setLoading] = createSignal(true)
  const [error, setError] = createSignal<string>()

  onMount(async () => {
    try {
      // await aifansSubscriptionApi.cancelAIFansSubscription(params.characterId)
      setLoading(false)

      // Send message to parent window after showing success state
      setTimeout(() => {
        window.parent.postMessage(
          { type: 'subscription-cancelled', characterId: params.characterId },
          '*'
        )
      }, 3000)
    } catch (err) {
      setError('Failed to cancel subscription. Please try again.')
      setLoading(false)
    }
  })

  return (
    <div class="flex h-screen w-full flex-col items-center justify-center bg-main p-4 text-center">
      {loading() ? (
        <>
          <div class="mb-4 h-8 w-8 animate-spin rounded-full border-4 border-cosplay-purple border-t-transparent"></div>
          <p class="text-gray-300">Cancelling your subscription...</p>
        </>
      ) : error() ? (
        <>
          <h1 class="mb-4 text-2xl font-bold text-red-500">Error</h1>
          <p class="text-gray-300">{error()}</p>
        </>
      ) : (
        <>
          <h1 class="mb-4 text-2xl font-bold">Subscription Cancelled</h1>
          <p class="text-gray-300">Your subscription has been successfully cancelled.</p>
          <p class="mt-4 text-sm text-gray-400">This window will close automatically...</p>
        </>
      )}
    </div>
  )
}

export default SubscriptionCancelled
